import selo from './assets/selo.svg'
import verticalLogo from './assets/vertical-logo.png'
import logo from './assets/logo-dark-bg.svg'
import facebook from './assets/facebook.svg'
import instagram from './assets/instagram.svg'
import twitter from './assets/x.svg'
import youtube from './assets/youtube.svg'
import linkedin from './assets/linkedin.svg'


const Footer = () => {

    const scrollTo = (id) => {
        try{
            document.getElementById(id).scrollIntoView({ 
                behavior: 'smooth',
                block: 'center'
            });
        }
        catch{
            window.location.href = `/#${id}`
        }
    }

    const checkAndRedirect = () => {
        if(window.location.href.split('/')[3].length > 0){
            window.location.href = '/'
        }
        else {
            window.scrollTo(0, 0)
        }
    }
    
    return ( 
        <div className="footer">
           <div className="left">
                <div className="selos">
                    <img src={verticalLogo} className='vertical-logo' alt="" />
                    <img src={selo} alt="" className="selo" />
                </div>
                <div className="ipj-info">
                    <img src={logo} alt="" className="logo" />
                    <span>O Instituto de Proteção ao Jogador  - IPJ foi criado com a missão de apoiar nossos clientes na promoção de um jogo responsável, oferecendo uma completa rede de apoio com suporte especializado na prevenção e apoio de pessoas com dependência em ludopatia, protegendo os jogadores e preservando a sustentabilidade do entretenimento.</span>
                </div>
           </div>
           <div className="right">
                <div className="footer-contato">
                    <h2>Contato</h2>
                    <span><bold>Telefone: </bold>0800 676 1000</span>
                    <span><bold>Email: </bold>atendimento@ipjbr.com.br</span>
                </div>
                <div className="footer-menu">
                    <h2>Menu</h2>
                    <span onClick={() => checkAndRedirect()}>Início</span>
                    <span onClick={() => scrollTo('apoio')}>Soluções</span>
                    <span onClick={() => scrollTo('sobre')}>Sobre</span>
                    <span onClick={() => scrollTo('funciona')}>Método</span>
                    <span onClick={() => scrollTo('contato')}>Contato</span>
                </div>
                <div className="footer-condicoes">
                    <h2>Condições legais</h2>
                    <span>Termos & condições</span>
                    <span>Política de privacidade</span>
                </div>
                <div className="footer-links">
                    <a href="/" target='_blank' rel='noreferrer'><img src={facebook} alt="" className='circle' /></a>
                    <a href="https://www.instagram.com/ipj.br" target='_blank' rel='noreferrer'><img src={instagram} alt="" className='circle' /></a>
                    <a href="/" target='_blank' rel='noreferrer'><img src={twitter} alt="" className='circle'/></a>
                    <a href="https://www.youtube.com/@InstitutodeProtecaoaoJogador" target='_blank' rel='noreferrer'><img src={youtube} alt="" className='circle'/></a>
                    <a href="/" target='_blank' rel='noreferrer'><img src={linkedin} alt="" className='circle'/></a>
                </div>
           </div>
        </div>
    );
}
 
export default Footer;